import React from "react";
import "./Black_Btn.css";
import { Button } from "react-bootstrap";

const Black_Btn = ({ btnText, onClick }) => {
  return (
    <Button className="Black_Btn" onClick={onClick}>
      {btnText}
    </Button>
  );
};

export default Black_Btn;
